import type { IChallenge, IObjective } from "@bbj-types/challenge";
import { tz } from "@date-fns/tz";
import { objectiveSchema } from "@root/utils/resolvers/challenge";
import { startOfDay } from "date-fns";
import { date, object, string } from "yup";
import type { TPaperCandidateChallengeObjective } from "../types";

export enum CandidateObjectiveFormLoadingState {
  NONE = 0,
  SUBMIT = 1,
  CANCEL = 2,
}

export interface IFormCandidateObjective {
  objective: IObjective | null;
  objectiveTitle: string;
  objectiveEndDate: Date | null;
}

export interface IResolverCandidateObjective {
  objective: IObjective;
  objectiveTitle: string;
  objectiveEndDate: Date | null;
}

export const resolver = (timeZone: string) =>
  object({
    objective: objectiveSchema.required("Le type d'objectif est obligatoire"),
    objectiveTitle: string().max(80, "Le titre ne peut excéder 80 caractères"),
    objectiveEndDate: date()
      .nullable()
      .typeError("Veuillez sélectionner une date valide")
      .test((value, context) => {
        if (value instanceof Date && value.getTime() < startOfDay(new Date(), { in: tz(timeZone) }).getTime()) {
          throw context.createError({
            path: context.path,
            message: "La date butoir doit être supérieure ou égale à la date du jour",
          });
        }
        return true;
      }),
  });

export const formatDefautValues = (
  challenge: Pick<IChallenge, "objectives">,
  candidateObjective: TPaperCandidateChallengeObjective | undefined
): IFormCandidateObjective => {
  if (candidateObjective === undefined) {
    return {
      objective: null,
      objectiveTitle: "",
      objectiveEndDate: null,
    };
  }
  return {
    objective: challenge.objectives.find((objective) => objective._id === candidateObjective.objective) ?? null,
    objectiveTitle: candidateObjective.label ?? "",
    objectiveEndDate: candidateObjective.deadline ?? null,
  };
};
